import React, { useCallback, useEffect, useState } from 'react'; 
import {
  Dialog,
  DialogContent,
  ToggleButton,
  ToggleButtonGroup,
  Box,
} from '@mui/material';
import MyPaperComponent from '../../common/components/MyPaperComponent';
import SetAppointmentReferral from '../../referral/SetAppointmentReferral';
import DeclineReferral from '../../referral/DeclineReferral';

export default function SetAppointmentReferralDialog({
  onOpen,
  onClose,
  history,
  uuid,
  reschedule,
  appointmentDate = null,
  status,
}) {
  // Determine if the toggle should be shown
  const showToggle = !(status === 'scheduled' || status === 'declined');

  // Default tab depending on status
  const getDefaultTab = useCallback(() => {
    if (status === 'scheduled') return 0; // Only show Set Appointment
    if (status === 'declined') return 1; // Only show Decline Referral
    return 0; // Default to Set Appointment if neither
  }, [status]);

  const [activeTab, setActiveTab] = useState(getDefaultTab());

  const handleTabChange = (event, newValue) => {
    if (newValue !== null) {
      setActiveTab(newValue);
    }
  };

  useEffect(() => {
    if (status) setActiveTab(getDefaultTab());
  }, [status, getDefaultTab]);

  return (
    <Dialog
      open={onOpen}
      onClose={onClose}
      PaperComponent={MyPaperComponent}
      aria-labelledby="draggable-dialog-title"
      maxWidth="md"
      fullWidth
    >
      {showToggle && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: 2,
            borderBottom: '1px solid #ddd',
          }}
        >
          <ToggleButtonGroup
            value={activeTab}
            exclusive
            onChange={handleTabChange}
            sx={{
              '& .MuiToggleButton-root': {
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                px: 3,
                py: 1,
                mx: 1,
                border: '1px solid #ccc',
                '&.Mui-selected': {
                  backgroundColor: '#1976d2',
                  color: 'white',
                  borderColor: '#1976d2',
                },
              },
            }}
          >
            <ToggleButton value={0}>Set Appointment</ToggleButton>
            <ToggleButton value={1}>Decline Referral</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}

      <DialogContent sx={{ padding: 0 }}>
        {(activeTab === 0 || status === 'scheduled') && (
          <SetAppointmentReferral
            history={history}
            uuid={uuid}
            handleClose={onClose}
            reschedule={reschedule}
            appointmentDate={appointmentDate}
          />
        )}
        {(activeTab === 1 || status === 'declined') && (
          <DeclineReferral
            uuid={uuid}
            setOpenDialog={onClose}
            history={history}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
